<div class="flex w-full animate-pulse flex-col items-center justify-center space-y-16">
  <div class="flex w-full flex-col items-start space-y-6">
    <div class="h-18 w-[10%] rounded-full bg-highlight bg-opacity-30" />
    <div class="h-40 w-full rounded-[15px] bg-highlight bg-opacity-30" />
  </div>
  <div class="h-[42px] w-[104px] rounded-[15px] bg-highlight bg-opacity-30" />
</div>
